import { render } from "./sound.svg?vue&type=template&id=5a4b9bfa"
const script = {}
script.render = render

export default script